import { FieldViewProps } from './types';
import { useFieldController } from './controller';
import { VerificationFieldContext } from './context';
import { FieldContainer } from './shared.styles';

export function Field({ type, allowGallery }: FieldViewProps) {
  const { contextData, onChangeImage, inputRef, ComponentByState, captureRef, isCapture } =
    useFieldController(type, allowGallery);

  return (
    <VerificationFieldContext.Provider value={contextData}>
      <FieldContainer>
        <ComponentByState />
      </FieldContainer>
      <input
        accept='image/*'
        ref={inputRef}
        type='file'
        onClick={(e) => e.stopPropagation()}
        onChange={onChangeImage}
        style={{ display: 'none' }}
      />
      {isCapture && (
        <input
          accept='image/*'
          type='file'
          ref={captureRef}
          onChange={onChangeImage}
          onClick={(e) => e.stopPropagation()}
          style={{ display: 'none' }}
          multiple={false}
          capture='user'
        />
      )}
    </VerificationFieldContext.Provider>
  );
}
